import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import ReportAbuseInsta from 'src/assets/images/report/reportAbuseInsta.jpg'

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },

  iframeContainer: {
    maxWidth: '80%',
    margin:'auto',
    padding: theme.spacing(0, 20, 20),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4, 15),
    },
  },

  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '64px',
    textAlign: 'center',
    lineHeight: '72px',
    textTransform: 'uppercase',
    color: theme.custom.whiteColor,
    // padding: theme.spacing(3, 0, 2),
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: '24px',
    color: theme.custom.whiteColor,
    padding: theme.spacing(4, 0, 0),
    margin: 'auto',
    opacity: '.7',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  sponsorBox: {
    width: '216px',
    height: ' 207.5px',
    margin: 'auto',
    textAlign: 'center',
    background:
      'linear-gradient(106.87deg, #DC86A0 2.25%, #A0C0E9 28.43%, #EAA539 54.12%, #848CC9 81.29%, #63D169 97.09%)',
  },
  reportAbuseContainer: {
    padding: theme.spacing(32, 25),
    height: 'auto',
    backgroundImage: `url(${ReportAbuseInsta?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '60px',
    backgroundPosition: 'center',
    backgroundSize: '100% 100%',
    [theme.breakpoints.down('sm')]: {
      // margin: theme.spacing(12, 0, 12),
      // borderRadius: pxToRem(44),
    },
  },
  sponsoredBy: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    color: theme.custom.whiteColor,
    padding: theme.spacing(8, 0, 0),
    [theme.breakpoints.down('md')]: {},
  },
}))

export default useStyles
